import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BeautyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BeautyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2611 9.18536C13.4435 8.98836 13.7471 8.98038 13.9391 9.16753C14.768 9.9754 16.0282 10.6895 18.7316 11.7989C18.9775 11.8998 19.0972 12.1861 18.9988 12.4384C18.9004 12.6907 18.6213 12.8134 18.3754 12.7125C15.6686 11.6018 14.2529 10.8306 13.2785 9.88093C13.0864 9.69378 13.0787 9.38236 13.2611 9.18536Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5384 4.73174C16.3015 4.61022 16.0134 4.70873 15.895 4.95177C15.0263 6.73406 14.1133 8.1966 12.8348 9.28476C11.5652 10.3654 9.89845 11.1073 7.47202 11.3764C7.20869 11.4056 7.01829 11.6483 7.04676 11.9184C7.07523 12.1886 7.31178 12.3839 7.57512 12.3547C10.1531 12.0688 12.0074 11.2676 13.4473 10.0421C14.8783 8.82401 15.8632 7.21718 16.7529 5.39183C16.8713 5.14879 16.7753 4.85326 16.5384 4.73174Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6718 4.55236C9.27643 4.55236 6.52393 7.37611 6.52393 10.8594C6.52393 12.1949 7.06243 13.5487 7.78812 14.5987L7.00565 15.1678C6.19802 13.9992 5.56475 12.4505 5.56475 10.8594C5.56475 6.83266 8.74669 3.56836 12.6718 3.56836C16.5969 3.56836 19.7788 6.83266 19.7788 10.8594C19.7788 12.2174 19.4165 13.4901 18.7852 14.5796L17.9607 14.0769C18.5063 13.1353 18.8197 12.0356 18.8197 10.8594C18.8197 7.37611 16.0672 4.55236 12.6718 4.55236Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.39702 11.4082C7.66189 11.4082 7.87661 11.6285 7.87661 11.9002V14.1558C7.87661 16.4188 8.81995 18.5739 10.4687 20.0774C11.8409 21.3287 13.9087 21.3287 15.2809 20.0774C16.9297 18.5739 17.873 16.4188 17.873 14.1558V12.3844C17.873 12.1126 18.0877 11.8924 18.3526 11.8924C18.6175 11.8924 18.8322 12.1126 18.8322 12.3844V14.1558C18.8322 16.6999 17.7717 19.1226 15.9182 20.8128C14.1826 22.3955 11.5671 22.3955 9.83147 20.8128C7.97794 19.1226 6.91743 16.6999 6.91743 14.1558V11.9002C6.91743 11.6285 7.13215 11.4082 7.39702 11.4082Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2296 13.9363C10.6834 13.6562 10.0406 13.6562 9.49446 13.9363C9.25756 14.0578 8.96948 13.9593 8.85103 13.7163C8.73258 13.4732 8.8286 13.1777 9.06551 13.0562C9.88168 12.6375 10.8424 12.6375 11.6585 13.0562C11.8954 13.1777 11.9915 13.4732 11.873 13.7163C11.7546 13.9593 11.4665 14.0578 11.2296 13.9363Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6421 4.49251C14.0327 2.43858 11.1786 2.49752 10.6503 4.57495C10.5835 4.83788 10.3215 4.99542 10.0652 4.92683C9.80892 4.85824 9.65535 4.5895 9.72221 4.32657C10.4947 1.28856 14.6686 1.20235 15.5597 4.206L15.5898 4.30751C15.6669 4.56746 15.524 4.84233 15.2706 4.92145C15.0172 5.00056 14.7493 4.85397 14.6722 4.59401L14.6421 4.49251Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2296 13.9363C15.6834 13.6562 15.0406 13.6562 14.4945 13.9363C14.2576 14.0578 13.9695 13.9593 13.851 13.7163C13.7326 13.4732 13.8286 13.1777 14.0655 13.0562C14.8817 12.6375 15.8424 12.6375 16.6585 13.0562C16.8954 13.1777 16.9915 13.4732 16.873 13.7163C16.7546 13.9593 16.4665 14.0578 16.2296 13.9363Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6746 17.219C13.1285 17.4991 12.4857 17.4991 11.9395 17.219C11.7026 17.0975 11.4145 17.196 11.2961 17.439C11.1776 17.682 11.2737 17.9776 11.5106 18.0991C12.3267 18.5177 13.2874 18.5177 14.1036 18.0991C14.3405 17.9776 14.4365 17.682 14.3181 17.439C14.1996 17.196 13.9115 17.0975 13.6746 17.219Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7597 18.3909L20.6922 18.5545C20.5553 18.8867 20.3056 19.1537 19.9931 19.3086C20.3056 19.4635 20.5553 19.7305 20.6922 20.0627L20.7597 20.2263L20.8271 20.0627C20.964 19.7305 21.2137 19.4635 21.5263 19.3086C21.2137 19.1537 20.964 18.8867 20.8271 18.5545L20.7597 18.3909ZM21.2014 16.9361C21.0363 16.5356 20.483 16.5356 20.3179 16.9361L19.8088 18.1712C19.7546 18.3028 19.6473 18.4037 19.5148 18.4477L18.3322 18.8405C17.8897 18.9875 17.8897 19.6297 18.3322 19.7767L19.5148 20.1695C19.6473 20.2135 19.7546 20.3144 19.8088 20.4459L20.3179 21.6811C20.483 22.0816 21.0363 22.0816 21.2014 21.6811L21.7105 20.4459C21.7648 20.3144 21.872 20.2135 22.0045 20.1695L23.1872 19.7767C23.6296 19.6297 23.6296 18.9875 23.1872 18.8405L22.0045 18.4477C21.872 18.4037 21.7648 18.3028 21.7105 18.1712L21.2014 16.9361Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.73463 14.7652L3.67447 14.932C3.52874 15.336 3.21824 15.6545 2.82442 15.804L2.66183 15.8658L2.82442 15.9275C3.21824 16.077 3.52874 16.3955 3.67447 16.7995L3.73463 16.9663L3.7948 16.7995C3.94052 16.3955 4.25102 16.077 4.64484 15.9275L4.80743 15.8658L4.64484 15.804C4.25102 15.6545 3.94052 15.336 3.7948 14.932L3.73463 14.7652ZM4.18441 13.1767C4.02991 12.7484 3.43935 12.7484 3.28485 13.1767L2.7749 14.5905C2.72633 14.7252 2.62283 14.8314 2.49156 14.8812L1.11345 15.4043C0.695909 15.5628 0.695908 16.1687 1.11345 16.3272L2.49156 16.8503C2.62283 16.9002 2.72633 17.0064 2.7749 17.141L3.28485 18.5548C3.43935 18.9832 4.02991 18.9832 4.18441 18.5548L4.69436 17.141C4.74294 17.0064 4.84644 16.9002 4.97771 16.8503L6.35582 16.3272C6.77336 16.1687 6.77336 15.5628 6.35582 15.4043L4.97771 14.8812C4.84644 14.8314 4.74294 14.7252 4.69436 14.5905L4.18441 13.1767Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BeautyIcon;
